import styles from './TermsAndConditions.module.scss'

const TermsAndConditions = () => {
    return (
        <div className={styles.terms}>
            <div className="container">
                <h1>Terms & Condition</h1>

                <p className={styles.terms__lastupdated}>
                    Last Updated: December 24, 2025
                </p>

                <div className={styles.terms__section}>
                    <div className={styles.terms__inline}>
                        <h3>1.1</h3>
                        <p>
                            These Terms & Conditions govern the provision of Chauffeur Rides Ltd services to its Customers and the nature of the relationship between Chauffeur Rides Ltd and its Customers.
                        </p>
                    </div>
                    <div className={styles.terms__inline}>
                        <h3>1.2</h3>
                        <p>
                            Notwithstanding any other agreements, policies or related documents which these Terms & Conditions reference, Chauffeur Rides Ltd and its Customers agree these Terms & Conditions represent the totality of the relationship between Chauffeur Rides Ltd and its Customers.
                        </p>
                    </div>
                    <div className={styles.terms__inline}>
                        <h3>1.3</h3>
                        <p>
                            The Terms & Conditions herein supersede all previous terms and constitute a legally binding agreement between Chauffeur Rides Ltd and its Customers
                        </p>
                    </div>
                </div>

                <div className={styles.terms__section}>
                    <h1>NATURE OF RELATIONSHIP – PRIVATE HIRE BOOKING SERVICE(S)</h1>

                    <div className={styles.terms__inline}>
                        <h3>2.1</h3>
                        <p>The Company is an incorporated company carrying on an independent business as a Private Hire Operator inviting, and accepting, Private Hire Booking(s).
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>2.2</h3>
                        <p>The Customer is a person making a Private Hire Booking with the Company for Transportation Services.
                            (s).
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.1</h3>
                        <p> The Customer shall ensure all information provided to the Company for a Private Hire Booking is accurate and correct.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.2</h3>
                        <p>  The Customer shall pay a Fare to the Company in consideration of the Private Hire Booking and Transportation Service.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3</h3>
                        <p>  The Customer shall pay any Additional Charge(s), howsoever incurred, to the Company, at a reasonable rate specified by the Company from time to time, for the following:
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.1</h3>
                        <p>   Airport parking expenses incurred during the Transportation Service(s).
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.2</h3>
                        <p>   Cancellation of a Private Hire Booking by the Customer after engagement, or commencement, of the Transportation Service.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.3</h3>
                        <p>   Congestion or Ultra Low Emission Zone (ULEZ) charge expenses incurred during the Transportation Service.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.4</h3>
                        <p>   Surcharge(s) in respect of the following:
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3> 3.3.4.1</h3>
                        <p>   Private Hire Booking(s) and Transportation Service(s) requiring transit from or to an airport or railway station.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>  3.3.4.2</h3>
                        <p>    Private Hire Booking(s) and Transportation Service(s) requiring transit out of London.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>   3.3.4.3</h3>
                        <p>     Private Hire Booking(s) and Transportation Service(s) requiring transit on Good Friday, Christmas Day or other bank holidays
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>  3.3.4.4</h3>
                        <p>     Private Hire Booking(s) and Transportation Service(s) requiring transit outside of normal business hours.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3> 3.3.4.5</h3>
                        <p> Private Hire Booking(s) and Transportation Service(s) requiring transit during periods of peak demand.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3> 3.3.4.6</h3>
                        <p> Private Hire Booking(s) and Transportation Service(s) requiring specific vehicle types.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.5</h3>
                        <p>  Variations to Private Hire Booking(s) and Transportation Service(s), from that accepted in the original Private Hire Booking, at the request of the Customer.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3> 3.3.6</h3>
                        <p>  Waiting time resulting from acts or omissions by the Customer during provision of the Transportation Service.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.3.7</h3>
                        <p>  Acts or omissions by the Customer during provision of the Private Hire Booking(s) and Transportation Service(s) resulting in expense or loss by the Company.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.4</h3>
                        <p>  The Customer shall, unless the Customer holds an Account or it is otherwise specified by the Company, make payment of the Fare and Additional Charges upon completion of the Transportation Service.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>3.5</h3>
                        <p>   The Customer Fares and Additional Charges shall, be collected by the Company collecting a credit or debit card payment using the Communication Software.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>4.1</h3>
                        <p>   The Company shall not be liable for any breach of its obligations resulting from a cause beyond its control including but not limited to fire, weather, strikes, insurrection, riots, embargoes, shortage of materials, delays in transportation, requirements of civil or military authority, war, civil unrest or terrorist action.
                        </p>
                    </div>

                    <div className={styles.terms__inline}>
                        <h3>4.2</h3>
                        <p>   The Company shall not, in the circumstances at Clause 4.1, be liable for any delay in performance or non-performance of any of its obligations due to force majeure
                        </p>
                    </div>
                </div>

                <div className={styles.terms__section}>
                    <h1>JURISDICTION
                    </h1>
                    <p>These Terms are governed by, and subject to, the laws of England.
                    </p>

                    <h2>Assorted Terms
                    </h2>
                    <ul>
                        <li>
                            By using our website or app, you ("Customer") agree to be bound by these Terms and Conditions ("Terms"). These Terms also apply to the supply of all transportation services and other services booked via the website (https://chauffeurrideskent.co.uk), telephone, email, SMS or App.
                        </li>

                        <li>
                            Whilst we do our utmost to ensure our drivers are punctual, you will understand that we cannot accept responsibility for delays caused by circumstances out of our control.
                        </li>

                        <li>
                            The driver will drive at safe and sensible speeds in accordance with road conditions, traffic and the legal speed limits.
                        </li>

                        <li>
                            Customers are responsible for any damage they cause to the interior and or exterior of a vehicle on hire to them and will be billed accordingly for any repair or valeting required in order to reinstate a vehicle to working order – as well as any subsequent loss of business for the driver for the consequence of their vehicle being off the road.
                        </li>

                        <li>
                            We may subcontract bookings to another private hire operator.
                        </li>

                        <li>By supplying your email address, you permit Chauffeur Rides ltd to contact you via email, in return, we promise never to supply your email to any third party. We reserve the right to change your vehicle or chauffeur at any time if necessary.
                        </li>

                        <li>Every effort will be made by Chauffeur Rides Ltd to ensure that our vehicle(s) or sub-contractors vehicle(s) arrive on time. It is the responsibility of the Customer to ensure that sufficient time is allowed for completion of the Service. Chauffeur Rides Ltd gives any advice on journey times in good faith but does not guarantee the completion of any journey in any specific time and will not be liable for any direct or consequential loss, delay or inconvenience caused to the Passenger(s) by the actual journey time (including but not limited to flight and hotel costs).
                        </li>

                        <li>Our Chauffeurs will travel by the most appropriate route on the day unless instructed otherwise by the Client at the time of booking.
                        </li>

                        <li>Chauffeur Rides Ltd vehicle(s) and sub-contracted vehicles are fully insured for passenger and third party claims. However, customer's properties are carried entirely at their own risk and Chauffeur Rides Ltd shall not be held responsible/liable for any loss/damage to such property.
                        </li>

                        <li>The Passenger shall be responsible for their luggage and personal items at all times and shall ensure that they are loaded into the vehicle prior to the commencement of the service and unloaded from the vehicle upon completion of the service. Chauffeur Rides Ltd will accept no responsibility for any loss or damage to luggage and personal items or consequential losses arising as a result of luggage and personal items that are not loaded or unloaded from the Passenger vehicle
                        </li>

                        <li>Chauffeur Rides Ltd will keep a lost property book at their office and will endeavour to return any lost goods left in our vehicle(s) or subcontracted vehicle(s) to the customer.
                        </li>

                        <li>Chauffeur Rides Ltd and its chauffeurs have the right to refuse to carry any passenger who is thought to be under the influence of alcohol or drugs and whose behaviour poses a threat either to the Chauffeur, the vehicle or any other passenger(s).
                        </li>

                        <li>
                            Chauffeur Rides Ltd maintains a strict non-smoking policy in all its vehicles.
                        </li>

                        <li>Online quotations do not allow for public and bank holidays like Christmas Day. On Christmas Day, Boxing Day and New Year's Day, there will be a 100% surcharge on all journeys. All other Bank Holidays will be subject to a 50% surcharge.
                        </li>

                        <li>
                            All major sporting events such as Wimbledon and Ascot are charged at a premium rate which may mean online bookings for these types of events may not be valid.
                        </li>

                        <li>Nothing contained in these terms and conditions can affect the Customers' statutory rights.</li>

                        <li>If a booking is cancelled by the Customer more than 24 hours from the start of the period of hire, all amount paid will be refundable.
                        </li>

                        <li>If a booking is cancelled by the Customer less than 24 hours from the start of the period of hire, 50% of the full cost of the journey will be payable.</li>

                        <li>If a booking is cancelled by the Customer less than 12 hours from the start of the period of hire, 100% of the full cost of the journey will be payable.
                        </li>

                        <li>If multiple vehicle bookings are cancelled by the Customer, within 7 days before the start of the period of hire, 100% of the full cost of the journeys will be payable.</li>

                        <li>Refunds and Processing Fees
                        </li>

                        <li>All refunded payments are subject to a processing fee to cover transaction costs incurred by Chauffeur Rides Ltd. This fee is non-refundable and will be deducted from the total amount refunded.
                        </li>

                        <li>Standard Refunds: If a refund is issued for any reason, a processing fee will be applied.
                        </li>

                        <li>Cancellations: If a booking is canceled within the eligible refund period, the refund will be processed minus the applicable processing fee.
                        </li>

                        <li>Payment Method Considerations: Refunds will be issued to the original payment method used at the time of booking. Additional bank or card processing fees may apply, which are the responsibility of the customer.
                        </li>

                        <li>Complaints
                        </li>
                    </ul>
                </div>

                <div className={styles.terms__section}>
                    <h2>Speak to us </h2>

                    <ul>
                        <li>If the customer has any complaints regarding Chauffeur Rides Ltd, the customer is encouraged to inform Chauffeur Rides Ltd as soon as possible, but no later than 7 days after the bookin</li>

                        <li>Chauffeur Rides Ltd will always try to facilitate an amicable solution to any complaint and may provide a refund or an account credit after the resolution of each case has been carefully looked into.
                        </li>
                    </ul>
                </div>

                <div className={styles.terms__section}>
                    <h2>Data Protection and Privacy</h2>

                    <ul>
                        <li>
                            Chauffeur Rides Ltd guarantees its customers that all their personal data remains safe and private. Any personal data that customers supply to Chauffeur Rides Ltd upon booking by app, online, email or phone will be used by Chauffeur Rides Ltd in accordance with its privacy policy only.
                        </li>

                        <li>
                            Chauffeur Rides Ltd uses the services of third party payment processors. Chauffeur Rides Ltd is not responsible or liable for any errors by these payment processors who hold PCI-DSS certificatio
                        </li>
                    </ul>
                </div>

                <div className={styles.terms__section}>
                    <h2>TRANSPORT SAFETY, CONSEQUENCES
                    </h2>

                    <div className={styles.terms__section}>
                        <h3>4.4.1 LUGGAGE, ANIMALS
                        </h3>

                        <p>
                            The price in the booking confirmation includes the number of pieces of luggage that were specified in the booking form.
                        </p>

                        <p>Excess luggage, bulky luggage such as a wheelchair, weapons or animals that the user wishes to carry along must be specified during the booking. Chauffeur Rides Ltd may refuse the transport of luggage, weapons and/or animals that have not been agreed upon; this also applies if animals are not housed in a closed and suitable transport box. </p>

                        <p>
                            The right of refusal does not exist if local statutory provisions of the region in which the transport is carried out require that the items be accommodated.
                        </p>
                    </div>

                    <div className={styles.terms__section}>
                        <h2>TRANSPORT OF CHILDREN AND MINORS
                        </h2>

                        <p>(A) CHILDREN The need for child restraints must be specified by the user in the ride request by specifying the number and age of the children to be transported as well as the type of child restraints required.
                        </p>

                        <p>(B) MINORS The transport of unaccompanied minors can be rejected by the Chauffeur Rides Ltd. The determination of minor status will be made in accordance with the statutory provisions of the region in which the transport is to be performed.
                        </p>
                    </div>

                    <div className={styles.terms__section}>
                        <h2>INFORMATION ON NUMBER OF PASSENGERS, NUMBER AND SIZE OF LUGGAGE
                        </h2>
                        <p>
                            The maximum number of passengers, number and size of pieces of luggage will be provided by Chauffeur Rides Ltd for a specific vehicle and is set out in a binding luggage policy.
                        </p>

                        <p>
                            Chauffeur Rides Ltd may refuse to transport passengers or luggage if, in its opinion, the space and safety conditions do not permit such transport.
                        </p>
                    </div>

                    <div className={styles.terms__section}>
                        <h2>NO-SHOW RIDES WITHOUT CANCELLATION, USER'S DELAY</h2>

                        <p>In the event that a user does not show up for a ride and does not cancel it (a "no show"), Chauffeur Rides Ltd shall still be entitled to compensation from the user.</p>

                        <p>(A) FOR TRANSFER AND LONG-DISTANCE RIDES A ride is considered to be a no-show if the User or guest does not appear within 30 minutes after the agreed pickup time at the agreed pickup location.
                        </p>

                        <p>In the event of pickup at airports or long-distance train stations, a ride is considered to be a no-show if the User or guest does not appear within 60 minutes after the agreed pickup time at the agreed pickup location.</p>

                        <p>
                            (B) HOURLY BOOKING A ride is considered to be a no-show if the User or guest does not appear at the agreed pickup location after the end of the booked hours (calculated from the scheduled pickup time).
                        </p>

                        <p>
                            In the event of pickup at airports or long-distance train stations, a ride is considered to be a no-show if the user or guest does not appear at the agreed location after the end of the booked hours according to the pickup time.
                        </p>

                        <p>
                            A user shall be fully liable for no-show rides. The hourly booking always starts at the agreed pickup time. In this respect, any extensions of the hourly booking must be remunerated. As a general rule, there is no right to change the pickup time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions